module.exports = __webpack_public_path__ + "img/home.d570a599.png";